"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _OverlayTrigger = _interopRequireDefault(require("rsuite-utils/lib/Overlay/OverlayTrigger"));

var _createChainedFunction = _interopRequireDefault(require("./utils/createChainedFunction"));

var Whisper =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(Whisper, _React$Component);

  function Whisper() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Whisper.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        triggerRef = _this$props.triggerRef,
        onOpen = _this$props.onOpen,
        onClose = _this$props.onClose,
        onEntered = _this$props.onEntered,
        onExited = _this$props.onExited,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["triggerRef", "onOpen", "onClose", "onEntered", "onExited"]);
    return React.createElement(_OverlayTrigger.default, (0, _extends2.default)({
      placement: "right",
      onEntered: (0, _createChainedFunction.default)(onOpen, onEntered),
      onExited: (0, _createChainedFunction.default)(onClose, onExited),
      ref: triggerRef // for test

    }, rest));
  };

  return Whisper;
}(React.Component);

(0, _defineProperty2.default)(Whisper, "handledProps", ["onClose", "onEntered", "onExited", "onOpen", "triggerRef"]);
var _default = Whisper;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/lib/Whisper.js
// module id = 315
// module chunks = 0